import React from "react";
import { getIn } from "formik";
import {
    FormControl,
    FormLabel,
    RadioGroup,
    FormControlLabel,
    Radio,
    FormHelperText,
    Typography,
} from "@mui/material";

export const RadioFormField = ({ field, form, label, options = [], isRequired, ...props }) => {
    const errorText = getIn(form.touched, field.name) && getIn(form.errors, field.name);

    return (
        <FormControl component="fieldset" error={!!errorText}>

            <Typography variant="body2" sx={{ textTransform: "capitalize", color: "text.secondary",fontSize:"12px" }}>
                {label}
                {isRequired && (
                    <Typography Typography variant="body1" color="error" component="span">
                        {" *"}
                    </Typography>
                )}
            </Typography>
            <RadioGroup
                row
                name={field.name}
                value={field.value}
                onChange={(e) => form.setFieldValue(field.name, e.target.value)}
                {...props}
            >
                {options.map((option) => (
                    <FormControlLabel
                        key={option.value}
                        value={option.value}
                        control={<Radio
                            sx={{
                                '&.Mui-checked': {
                                    color: '#DC143C', // red dot
                                },
                            }}
                        />}
                        label={option.label}
                    />
                ))}
            </RadioGroup>
            {errorText && <FormHelperText>{errorText}</FormHelperText>}
        </FormControl>
    );
};
